// src/components/BlogPostDetail/BlogPostDetail.js
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Import useNavigate
import './BlogPostDetail.scss'; // New SCSS file for this component
import {Trans} from "@lingui/react/macro"
import t from "@lingui/core/macro"
import { useLingui } from "@lingui/react"; // <--- Import useLingui

const BlogPostDetail = ({ posts }) => {

    const { postSlug } = useParams(); // Get the slug from the URL
    const navigate = useNavigate(); // Hook for navigation
    const { i18n } = useLingui(); // <--- Get the i18n object
    // Find the post by slug from the array passed from NovedadesRouter
    const post = posts.find(p => p.slug === postSlug);

    // Effect to update document title or handle 'post not found'
    useEffect(() => {
        if (!post) {
            document.title = t`Artículo no encontrado`;
            // You could also redirect to /novedades or a 404 page:
            // navigate('/novedades', { replace: true });
        } else {
            document.title = post.title;
        }
    }, [post, navigate]); // Add dependencies if navigate is used in useEffect

    // Display a message if the post is not found
    if (!post) {
        return (<div className="toplevel not-found" >
            <div className="blog-post-detail-container not-found">
                <Trans><p>El artículo solicitado no se encuentra.</p></Trans>
                <button onClick={() => navigate(-1)} className="back-button">
                    &larr;<Trans>Volver</Trans>
                </button>
            </div></div>
        );
    }

    // Format the date for display
    const formattedDate = post.date.toLocaleDateString(i18n.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone:'UTC'
    });

    // Image path
    const imageUrl = post.image ? `${process.env.PUBLIC_URL}/images/blog/${post.image}` : null;
    return (
        <div className="toplevel">
        <div className="blog-post-detail-container">
            {/* Top "Go Back" button */}

            <h1 className="post-detail-title">{post.title}</h1>
            {post.subtitle && <h2 className="post-detail-subtitle">{post.subtitle}</h2>}
            <p className="post-detail-date">{formattedDate}</p>

            {imageUrl && (
                <div className="post-detail-image-wrapper">
                    <img src={imageUrl} alt={post.title} title={post.imageDescription} className="post-detail-image" />
                </div>
            )}

            {/* Full body content, rendered as HTML */}
            <div className="post-detail-body">
                <div dangerouslySetInnerHTML={{ __html: post.bodyHtml }} />
            </div>

            {/* Bottom "Go Back" button */}
            <button onClick={() => navigate(-1)} className="back-button bottom">
                &larr; <Trans>Volver a Novedades</Trans>
            </button>
        </div>
        </div>
    );
};

export default BlogPostDetail;